import { BaseContainerModel } from '../../base-container.model';
import { bl_pricing_scheme_copy_processor_status_hdr_RowClass } from '../../../dbschema';

export class PricingSchemeCopyProcessorStatusHdrContainerModel extends BaseContainerModel {
  bl_pricing_scheme_copy_processor_status_hdr: bl_pricing_scheme_copy_processor_status_hdr_RowClass = new bl_pricing_scheme_copy_processor_status_hdr_RowClass();
}
